"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dompurify_1 = __importDefault(require("dompurify"));
// Sanitize any string inside an object to prevent XSS attacks
function sanitizeObject(object) {
    var sanitized = {};
    // Return input data if it's not an object
    if (typeof object !== 'object') {
        return object;
    }
    // Sanitize all string values in the object
    Object.keys(object).forEach(function (key) {
        if (typeof object[key] === 'string' && typeof dompurify_1.default.sanitize === 'function') {
            sanitized[key] = dompurify_1.default.sanitize(object[key]);
        }
        else {
            sanitized[key] = object[key];
        }
    });
    return sanitized;
}
exports.default = sanitizeObject;
